import { gql } from '@urql/core';
import React from 'react';
import { PlayerBioCardFragment } from '../../../generated/spin-graphql';
import { Biography } from '../../profiles/Biography';
import { PlayerInfoButtons } from './PlayerInfoButtons';
import { PlayerProfileInfo } from './PlayerProfileInfo';

type Props = {
    player: PlayerBioCardFragment;
};

gql`
    fragment PlayerBioCard on espin_player_profile {
        bio
        phone
        user {
            email
            subscription_status {
                is_subscribed
            }
        }
        social {
            discord
        }
        ...PlayerProfileInfo
        ...PlayerInfoButtons
    }
`;

export const PlayerBioCard: React.FC<Props> = ({ player }) => {
    // player info will be shown here always - just hidden from the ui in the actual component depending on the viewer info.
    const hasPlayerInfoButtons = player.phone || player.user.email || player.social?.discord;

    return (
        <div className="player-bio-container">
            <PlayerProfileInfo player={player} />
            {hasPlayerInfoButtons && <PlayerInfoButtons player={player} />}
            {player.bio && <Biography biography={player.bio} />}
        </div>
    );
};
